module.exports = __webpack_public_path__ + "img/vail_slide_1.39e2eb4c.jpg";